import { render, staticRenderFns } from "./ProfileTotalScore.vue?vue&type=template&id=19ffa142&scoped=true&lang=pug"
import script from "./ProfileTotalScore.vue?vue&type=script&lang=js"
export * from "./ProfileTotalScore.vue?vue&type=script&lang=js"
import style0 from "./ProfileTotalScore.vue?vue&type=style&index=0&id=19ffa142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ffa142",
  null
  
)

export default component.exports